// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;Draw the spear and bar the way<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;against those who pursue me;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;say to my soul, &#145;I am your salvation.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;